import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getDefaultMobileWidth } from '../../custom-hooks/screen-detector';
import { sanitizeThemeStyleByNumber } from '../../helpers/style';

const Box = styled.div`
  ${props => (props.$fontFamily ? `font-family: ${props.$fontFamily}` : null)};
  ${props => (props.$margin ? `margin: ${props.$margin}` : null)};
  ${props => (props.$padding ? `padding: ${props.$padding}` : null)};
  ${props =>
    props.$backgroundColor
      ? `background-color: ${props.$backgroundColor}`
      : null};
  ${props => (props.$border ? `border: ${props.$border}` : null)};
  ${props =>
    props.$borderRadius ? `border-radius: ${props.$borderRadius}` : null};

  ${props => (props.$width ? `width: ${props.$width}` : null)};
  ${props => (props.$height ? `height: ${props.$height}` : null)};
  ${props => (props.$maxWidth ? `max-width: ${props.$maxWidth}` : null)};

  @media (max-width: ${getDefaultMobileWidth()}px) {
    padding: ${props => props.$mobilePadding};
    margin: ${props => props.$mobileMargin};
  }
`;

export const MBox = forwardRef(
  (
    {
      padding,
      margin,
      mobilePadding,
      mobileMargin,
      border,
      borderRadius,
      width,
      height,
      maxWidth,
      backgroundColor,
      fontFamily,
      className,
      children,
    },
    ref,
  ) => (
    <Box
      $padding={padding}
      $margin={margin}
      $mobilePadding={mobilePadding}
      $mobileMargin={mobileMargin}
      $border={border}
      $borderRadius={borderRadius}
      $width={sanitizeThemeStyleByNumber(width)}
      $height={sanitizeThemeStyleByNumber(height)}
      $maxWidth={sanitizeThemeStyleByNumber(maxWidth)}
      $backgroundColor={backgroundColor}
      $fontFamily={fontFamily}
      className={className}
      ref={ref}
    >
      {children}
    </Box>
  ),
);

MBox.propTypes = {
  padding: PropTypes.string,
  margin: PropTypes.string,
  mobilePadding: PropTypes.string,
  mobileMargin: PropTypes.string,
  border: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  maxWidth: PropTypes.string,
  fontFamily: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};
